import { UPLOAD_DOCUMENTS_FORM_KEYS } from '../../constants/formKeys';

export const getCheckListPayload = (formData, documentTypes, claimNumber) => {
  const documentCheckListPayload = documentTypes.map((docType) => {
    const checklistKey = `${docType}_CHECKLIST`;
    return {
      Id: 0,
      ClaimNumber: claimNumber,
      DocumentType: docType,
      IsCheck: !!formData[checklistKey],
      IsSubmitted: false,
      Modified: new Date().toISOString(),
      Created: new Date().toISOString()
    };
  });
  return documentCheckListPayload;
};

// Filter documentTypes in formData that have length > 0 and create claimAttachments payload
export const getAttachmentsPayload = (formData, documentTypes, claimNumber) => {
  const claimAttachmentsPayload = documentTypes
    .filter((docType) => {
      const files = formData[docType];
      return files && typeof files.length === 'number' && files.length > 0;
    })
    .flatMap((docType) => {
      const files = formData[docType];
      return Array.from(files).map((file) => {
        const lastModifiedDate = file.lastModified ? new Date(file.lastModified) : new Date();
        return {
          Id: 0,
          ClaimNumber: claimNumber,
          FileName: file.name || '',
          FileSize: file.size || '',
          DocumentType: docType,
          Created: lastModifiedDate.toISOString(),
          Modified: lastModifiedDate.toISOString(),
          DocumentId: file.documentId,
          DocumentPath: file.path,
          StorageApiURL: '',
          IsAttachmentSentToCOS: true,
          COSReference: ''
        };
      });
    });
  return claimAttachmentsPayload;
};

export const getCommonPayload = (formData, claimNumber, policyNumber) => {
  const documentTypes = Object.values(UPLOAD_DOCUMENTS_FORM_KEYS).filter(
    (key) => !key.endsWith('_CHECKLIST') && key !== 'COMMENTS'
  );
  const documentCheckListPayload = getCheckListPayload(formData, documentTypes, claimNumber);
  const claimAttachmentsPayload = getAttachmentsPayload(formData, documentTypes, claimNumber);

  const payload = {
    ClaimAttachments: claimAttachmentsPayload,
    DocumentTypeCheckLists: documentCheckListPayload,
    ClaimComment: {
      Id: 0,
      DocumentType: 'Comment',
      ClaimNumber: claimNumber,
      Comment: formData[UPLOAD_DOCUMENTS_FORM_KEYS.COMMENTS] || '',
      IsSentToCOS: false,
      COSReference: '',
      Modified: new Date().toISOString(),
      Created: new Date().toISOString()
    },
    ClaimNumber: claimNumber,
    PolicyNumber: policyNumber,
    Source: 1,
    IsAdditional: true
  };
  return payload;
};
